import React from 'react';
import { Accordion } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { getSAdvEvents, setRadioValue } from '../../../Redux/actions/actions';
import { useEffect, useState } from 'react';
import { EVENT_DOESNT_MEETS_CASE, EVENT_MEETS_CASE } from '../../../utilities';

const BrightonCaseUpdateAE =({handleReset, radioValue, handleRadioBtn, radioReset, getEventDescId}) => {
    const dispatch = useDispatch()
    // const radioValue = useSelector((state) => state.radioValue);
    const studyAeDtls = useSelector((state) => state.getStudyAeDtls);
    const [selectedEvent, setSelectedEvent] = useState([])
    const [radioStat, setRadioStat] = useState([])
    const [firstOption,setFirstOption]=useState(false);
    const [secondOption, setSecondOption]=useState(false);

    useEffect(() => {
      if(studyAeDtls !==null) 
      { setSelectedEvent(studyAeDtls)}
      dispatch(getSAdvEvents())
      if(radioValue !==null) 
      {setRadioStat(radioValue)}
      
    }, [dispatch, studyAeDtls, radioValue] )

    useEffect(() => {
    let filteredData = selectedEvent[0]&&selectedEvent[0]?.event_meets_case?.filter(elem=>elem.study_event_meets_case_id ===radioStat && elem)
    let filteredData1 = selectedEvent[1]&&selectedEvent[1]?.event_doesnt_meets_case?.filter(elem=>elem.study_event_doesnt_meets_case_id ===radioStat && elem)
      let valueToSet;
      if (filteredData && filteredData.length > 0) {
        valueToSet = "1";
      } else if (filteredData1 && filteredData1.length > 0) {
        valueToSet = "2";
      }
      setAccordianItemNumber(valueToSet);
    }, [selectedEvent]);


const [accordianItemNumber,setAccordianItemNumber] = useState()

    

const handleOptionChange=(e)=>{
  handleReset('')
  setTimeout(() => {
     
  let value = e.target.value 
    dispatch(setRadioValue(value))
    handleRadioBtn(value)
    let filteredData = selectedEvent[0]&&selectedEvent[0]?.event_meets_case?.filter(elem=>elem.study_event_meets_case_id ===value && elem)
    let filteredData1 = selectedEvent[1]&&selectedEvent[1]?.event_doesnt_meets_case?.filter(elem=>elem.study_event_doesnt_meets_case_id ===value && elem)
    
    let data = filteredData?.map(i => ({
      ...i,
      event_description_id: i.study_event_meets_case_id,
      is_case_meets: EVENT_MEETS_CASE
    }));
     let data1 =filteredData1?.map(i => ({
      ...i,
      event_description_id: i.study_event_doesnt_meets_case_id,
      is_case_meets: EVENT_DOESNT_MEETS_CASE
    }));

    if(filteredData.length>0)
    {
      setAccordianItemNumber("1")
      setFirstOption(true);
      setSecondOption(false);
        getEventDescId(data[0])
    }else if(filteredData1.length>0)
    {
      setAccordianItemNumber("2")
      setFirstOption(false);
      setSecondOption(true);
        getEventDescId(data1[0])
    }else{
        getEventDescId()
    }
  }, 100);
}

    return (
        <div className='d-flex flex-column gap-2'>
        <Accordion alwaysOpen={true} activeKey={accordianItemNumber}>
            <Accordion.Item onClick={()=>{setAccordianItemNumber("1")}} eventKey={"1"} className='accordion_item_cls'>
              
                                  <Accordion.Header>
                                    <div className="custm-radio-styl" style={{color: firstOption ? 'green' : 'black' }}>
 
                                        Event meets case definition
                              

                                    </div>
                                  </Accordion.Header>
                                  {selectedEvent &&
                                    selectedEvent[0]?.event_meets_case?.map((i) => {
                                        
                                      return (
                                        <Accordion.Body  key={i.study_event_meets_case_id}>
                                          <div className="">
                                            <div className="custm-radio-styl">
                                              <label
                                                htmlFor={i.study_event_meets_case_id}
                                                style={{
                                                  display: "flex",
                                                  alignItems: "start",
                                                  marginLeft:"10px",
                                                  cursor:"pointer",
                                                  color: radioValue ? 'green' : 'black' // Change text color
                                                }}
                                              >
                                                <input
                                                  type="radio"
                                                  id={i.study_event_meets_case_id}
                                                  value={radioReset==='reset'?null:i.study_event_meets_case_id}
                                                  checked={radioReset==='reset'?null:radioStat === i.study_event_meets_case_id}
                                                  onChange={handleOptionChange}
                                                  style={{ width: "20px" , marginRight: "10px", alignSelf:"start", cursor:"pointer"}}
                                                />
                                                  {
                                                    i.study_event_meets_case_definition
                                                  }
                                                
                                              </label>

                                            </div>
                                          </div>
                                        </Accordion.Body>
                                      );
                                    })}
                                </Accordion.Item>


                                {/* =========================not met=================== */}
                                <Accordion.Item onClick={()=>{setAccordianItemNumber("2")}} eventKey={"2"}  className='accordion_item_cls'>
                                  <Accordion.Header>
                                    <div className="custm-radio-styl" style={{color: secondOption ? 'green' : 'black' }}>
                                        Event does not meet case definition
                                    </div>
                                  </Accordion.Header>
                                  {selectedEvent &&
                                    selectedEvent[1]?.event_doesnt_meets_case?.map(
                                      (i) => {
                                        return (
                                          <Accordion.Body key={i.study_event_doesnt_meets_case_id}>
                                            <div className="">
                                              <div className="custm-radio-styl">
                                                <label
                                                  htmlFor="notmetcase"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "start",
                                                    cursor:"pointer",
                                                    marginLeft: "10px"
                                                  }}
                                                >
                                                  <input
                                                    type="radio"
                                                    id="notmetcase"
                                                    value={radioReset==='reset'?null:i.study_event_doesnt_meets_case_id}
                                                    checked={radioReset==='reset'?null:radioStat===i.study_event_doesnt_meets_case_id}
                                                     onChange={handleOptionChange}
                                                    style={{ width: "20px" }}
                                                  />
                                                  <span
                                                    style={{ marginLeft: "10px" }}
                                                  >
                                                    {
                                                      i.study_event_doesnt_meets_case_definition
                                                    }
                                                  </span>
                                                </label>
                                              </div>
                                            </div>
                                          </Accordion.Body>
                                        );
                                      }
                                    )}
                                </Accordion.Item>
                                </Accordion>
                                
        </div>
    );
};

export default BrightonCaseUpdateAE;
